import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-consent-dialog',
  templateUrl: './consent-dialog.component.html',
  styleUrls: ['./consent-dialog.component.scss']
})
export class ConsentDialogComponent implements OnInit {
  isChecked = false;
  noticeText = '';
  privacyContent: string = '';


  constructor(private http: HttpClient, public dialogRef: MatDialogRef<ConsentDialogComponent>) { }

  ngOnInit(): void {
    // this.http.get('assets/privacy-notice.html', { responseType: 'text' })
    //   .subscribe(data => {
    //     this.privacyContent = data;
    //   });

      const consent = sessionStorage.getItem('userConsent');
    if (consent) {
      this.isChecked = consent === 'true';
    }
  }
  

  onAgree() {
    if (this.isChecked) {
      sessionStorage.setItem('userConsent', 'true');
      this.dialogRef.close(true);
    }
  }

  onCancel() {
    sessionStorage.setItem('userConsent', 'false');
    this.dialogRef.close(false);
  }

}
